import { useEffect, useState, useMemo, } from 'react';

import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import MuiAlert from '@material-ui/lab/Alert';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';

import './styles.css';

import { showToast } from '../../ui-lib/toast';
import 'react-toastify/dist/ReactToastify.css';

import { listCompanies, createCompany, changeCompanyActiveState, } from '../../services/api';

import CompanyForm from '../../components/CompanyForm/index';
import NavBar from '../../components/NavBar/NavBar';
import CompaniesTable from '../../components/CompaniesTable';


function Empresas() {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const activeCompanies = useMemo(() => companies.filter(({ ativa, }) => ativa === 1), [companies]);
  const inactiveCompanies = useMemo(() => companies.filter(({ ativa, }) => ativa === 0), [companies]);


  function onCreateCompany({ name, contrato, pacote, }) {
    if (loading) {
      return;
    }

    setLoading(true);
    createCompany(name, contrato, pacote, true, 0)
      .then(() => {
        showToast({
          type: 'success',
          message: 'Empresa criado com sucesso',
        })
        getData();
      })
      .catch(({ data }) => {
        console.log(data);
        return showToast({
          type: 'error',
          message: 'Erro ao criar ao criar empresa',
        })
      })
      .finally(() => {
        setLoading(false);
      });
  }

  async function onChangeCompanyActiveState(companyId, isActive) {
    try {
      await changeCompanyActiveState(companyId, isActive);

      const updatedCompanies = [...companies];
      const companyIdx = companies.findIndex(({ _id, }) => companyId === _id);
      if (companyIdx > -1) {
        updatedCompanies[companyIdx] = {
          ...updatedCompanies[companyIdx],
          ativa: isActive ? 1 : 0,
        }
      }
      setCompanies(updatedCompanies);
    } catch (error) {
      console.log(error);
      return showToast({
        type: 'error',
        message: 'Erro ao mudar status da empresa',
      });
    }
  }

  function Alert(props) {
    return <MuiAlert elevation={3} variant="filled" {...props} />
  }

  async function getData() {
    try {
      const { data, } = await listCompanies();
      setCompanies(data);
    } catch (error) {
      //TODO: handle error
    }
  }

  useEffect(() => {
    getData();
  }, []);


  return (
    <NavBar>
      <Container
        component={Paper}
        style={{
          padding: '1rem',
          marginBottom: '1rem',
        }}
      >
        <Alert
          color="warning"
          severity="error"
          icon={<AddCircleOutlinedIcon fontSize="inherit" />}
          style={{
            width: '50%',
            marginLeft: '25%',
            marginBottom: '1rem',
          }}
        >
          Cadastrar uma nova empresa
        </Alert>

        <CompanyForm
          loading={loading}
          onSubmit={onCreateCompany}
        />
      </Container>

      <Container
        component={Paper}
        style={{
          padding: '1rem',
        }}
      >
        <Alert
          variant="filled"
          severity="info"
          style={{
            width: '50%',
            margin: '1rem auto',
          }}
        >
          Todos as empresas ativas
        </Alert>

        <CompaniesTable
          companies={activeCompanies}
          onChangeCompanyActiveState={onChangeCompanyActiveState}
        />

        <Alert
          variant="filled"
          severity="warning"
          style={{
            width: '50%',
            margin: '1rem auto',
          }}
        >
          Todos as empresas desativadas
        </Alert>

        <CompaniesTable
          companies={inactiveCompanies}
          onChangeCompanyActiveState={onChangeCompanyActiveState}
        />
      </Container>
    </NavBar>
  );
}

export default Empresas;
